/* eslint max-len: "off" */
module.exports = {
    67102: 'Expense category has been linked and cannot be deleted',
    67103: 'The training location has been linked and cannot be deleted',
    64111: 'The time cannot be empty after the registration is started',
    64110: 'Starting time cannot be greater than or equal to the end time',
    67101: 'The classroom has been linked and cannot be deleted',
    64113: 'Please enter a positive integer within 0-10000 for the number of quotas',
    63101: 'The class student does not exist',
    64112: 'Starting time cannot be greater than or equal to the registration deadline',
    63102: 'The staff number does not exist',
    64115: 'The reporting personnel number does not exist',
    67104: 'Class category has been linked and cannot be deleted',
    63103: 'The staff number is not within your scope of authorization',
    64114: 'The reporting department does not exist or is not within your scope of authorization',
    63104: 'This user is already a formal student',
    64117: 'Reporting department data already exists',
    64116: 'The reporting staff number is not within your scope of authorization',
    64119: 'The registration time is not reached',
    64118: 'Registration time has expired',
    60109: 'The current registration end time has exceeded the class end time',
    60703: 'Lecturer configuration fees can not be less than the lecturer\'s budget expense details',
    60119: 'Please enter a positive integer within 0-10000 for the planned number of peesonnel',
    60118: 'Class category does not exist',
    60117: 'Implementation department does not exist or is not within your scope of authorization',
    60116: 'The affiliation department does not exist or is not within your scope of authorization',
    60115: 'The staff number of class teacher is not within your scope of authorization',
    60995: 'Unauthorized operation',
    60114: 'The staff number of class teacher does not exist',
    60112: 'Training plan does not exist',
    60111: 'You are not authorized to participate in the class',
    60110: 'You are not a class student and have no right to view',
    64120: 'The student has registered',
    66101: 'Associated personnel have added internal lecturers',
    64121: 'Class not assigned class certificate',
    62101: 'The class activity sign-in does not exist',
    62102: 'The class activity sign-in has not yet started',
    62103: 'The class activity sign-in has ended',
    62104: 'The class does not need sign-in',
    62105: 'The activity participants have signed in',
    60603: 'Classroom configuration does not exist',
    60602: 'The table type in the classroom does not exist',
    60601: 'Classroom number already exists',
    60126: 'The reporting has been closed and cannot be deleted',
    60125: 'The reporting has been closed and cannot be edited',
    60201: 'You are not a lecturer or your lecturer status is disabled',
    60002: 'Imported data exceeds limit number',
    60003: 'This business data exists in the import task in the queue. Please try again later',
    60123: 'Reporter required',
    60001: 'Imported template error',
    60122: 'The reporting department already exists, please select another department',
    60121: 'The reported data does not exist',
    60120: 'Time format error',
    20114: 'The staff number does not exist',
    65101: 'Lecturer level is associated and cannot be removed',
    60605: 'Classroom numbers can only be filled with numbers, letters, _',
    60604: 'Repeated class number import',
    61103: 'No training plan found',
    61102: 'This status cannot be deleted',
    61101: 'The number of class teachers exceeds the limit',
    60131: 'The class has been closed',
    60130: 'The class is full!',
    64102: 'The time cannot be empty after the registration is started',
    64101: 'Data cannot be deleted in this state',
    64104: 'Class does not exist',
    64103: 'Starting time of the registration cannot be greater than or equal to the end time of the registration',
    41001: 'The staff number is not within your scope of authorization',
    64106: 'The class can only be re-released in the revocation state',
    64105: 'The class cannot be revoked in this state',
    64108: 'In the registration status, the end time must be less than the start time',
    64107: 'The registration deadline cannot be greater than or equal to the class start time',
    64109: 'Class time cannot be empty',
    60108: 'Already a class member or already enrolled',
    60702: 'Lecturer fees exceed class lecturer configuration fees',
    60107: 'The number of applicants in this class is full.',
    60701: 'Class expenses exceed class budget',
    60106: 'The class is required to fill in the reason for registration',
    60105: 'The current training class registration has ended',
    60104: 'The resource no longer exists',
    60103: 'The deadline for reporting has passed',
    60102: 'The number of reporting people exceeds the number of quotas',
    60101: 'You have been disqualified for reporting',
    60100: 'The current training class registration has not yet started',
    62107: 'The QR code has expired',
    68005: 'Exam does not exist or does not support offline exams',
    68003: 'The employee number is duplicated',
    68002: 'Offline test scores required',
    68009: 'Activity chapter does not exist',
    68008: 'Score out of range',
    64123: 'The number of imported referrals is up to 10',
    68007: 'The score format is incorrect',
    68006: 'The event does not exist',
    201603: 'The file content is empty',
    20906: 'The template is wrong, please import the correct template',
    68001: 'Employee ID is required',
    68010: 'Invalid score',
    68011: '在线课程业务数据异常',
    62108: '不能删除已有学员参与的签到活动',
    60136: '使用费用请输入0-100000以内最多两位小数的数值',
    60137: '成绩请输入0-1000以内最多一位小数的数值',
    63105: '协议开始时间缺失，无法导入',
    63106: '协议截止时间缺失，无法导入',
    68004: '员工不是班级学员',
    68012: '员工不是培训班补考学员',
    60138: '请选择人员提报！',
    69001: '课程编码不存在',
    69002: '开始时间不能小于班级开始时间',
    69003: '结束时间不能大于班级结束时间',
    69004: '开始时间不能大于等于结束时间',
    69005: '单次最多导入100条数据，请分批导入',
    69006: '课程编码重复',
    60144: '活动已结束',
    60145: '活动还未开始',
    69007: '附件转换中'
};
